import React from 'react'

const SvgCalculateFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 2a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h16zM8.25 12.75a1 1 0 00-1 1v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1v-1a1 1 0 00-1-1zm5.5 3.5a1 1 0 100 2h4a1 1 0 100-2h-4zm0-3a1 1 0 100 2h4a1 1 0 100-2h-4zm3.996-7.003a1 1 0 00-1.414 0l-.586.586-.586-.586a1 1 0 00-1.414 1.414l.586.586-.586.586a1 1 0 101.414 1.414l.586-.586.586.586a1 1 0 001.414-1.414l-.586-.586.586-.586a1 1 0 000-1.414zM6.25 7.25a1 1 0 000 2h4a1 1 0 100-2h-4z'
    />
  </svg>
)

export default SvgCalculateFilled
